module.exports = __webpack_public_path__ + "b8163006dbfc5ae9cd287eeb4faa36eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/service/four/four-bg.jpg
// module id = 1208
// module chunks = 0